import React, { useCallback, useContext, useMemo, useState } from 'react';
import getUserDisplayName from '../../../contextProviders/SplashScreenProviders/UserAndAccountProviders/UsersProvider/getUserDisplayName';
import UsersContext from '../../../contexts/UsersContext';

const useSearchUsers = (
  usersGreenList?: (UserManagement.PendingUser | UserManagement.SignedUpUser)[],
) => {
  const { signedUpAndPendingUsers } = useContext(UsersContext);
  const [searchText, setSearchText] = useState<string>('');
  const onSearchTextChanged = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setSearchText(event.target.value);
    },
    [],
  );

  const availableUsers = useMemo(() => {
    if (usersGreenList) {
      return usersGreenList;
    }

    return signedUpAndPendingUsers;
  }, [signedUpAndPendingUsers, usersGreenList]);

  const filteredUsers = useMemo(() => {
    if (searchText === '') {
      return availableUsers;
    }

    return availableUsers.filter((u) =>
      getUserDisplayName(u).includes(searchText),
    );
  }, [searchText, availableUsers]);

  return {
    filteredUsers,
    searchText,
    onSearchTextChanged,
  };
};

export default useSearchUsers;
